import React from 'react';
import ModalFormUI from '../../../../widgets/form/ModalFormUI';
import InputDateUI from '../../../../widgets/form/InputDateUI';
import InputTextSF from '../../../../widgets/form/InputTextSF';

const ChargeAmountModalUI = ({
    context, successMsg, errorList, setErrorList, submitted,
    onSubmit, onCancelClick, updateMode,
    paidDate, onPaidDateChange, paidDateError, setPaidDateError,
    amount2, onAmount2Change, amount2Error, setAmount2Error,
}) => (
    <ModalFormUI
        context={context}
        titleLabel='Update Charge Amounts' // Title updated for clarity
        buttonLabel='Save'
        cancelLabel='Cancel'
        isOpen={updateMode}
        onRequestClose={onCancelClick}
        successMsg={successMsg}
        errorList={errorList}
        setErrorList={setErrorList}
        onSubmit={onSubmit}
        busy={submitted}
    >
        <InputDateUI
            context={context}
            name='paidDate'
            label='Paid Date'
            selectedDateISO={paidDate}
            onChange={onPaidDateChange}
            error={paidDateError}
            setError={setPaidDateError}
        />
        <InputTextSF
            type='text'
            name='amount2'
            label='Amount' // New label for Amount 2
            value={amount2}
            onChange={onAmount2Change}
            error={amount2Error}
            setError={setAmount2Error}
        />
    </ModalFormUI>
);

export default ChargeAmountModalUI;
